<template>
	<div class="_sidinnehall_snabbval-container" :class="{focus: isInFocus }"
		  @keydown.tab="isTabbed = true">
		<div class="input-wrapper"
			  @click="showSuggestions"
			  @input="onInput"
			  @keydown="moveSelection($event), onAutocomplete($event)"
			  @keyup="onListKeyUp"
			  ref="inputSlot">
			<slot>
				<input class="shadow"
						 ref="shadow"
						 type="text"
						 :value="shadowValue"
						 readonly>

				<input v-if='!isTouchDevice'
						 ref="input"
						 type="text"
						 v-bind="$props"
						 :value="text || ''"
						 placeholder='Snabbval'
						 name="snabbval"
						 autocomplete="off">
				<input v-if='isTouchDevice'

						 ref="input"
						 type="text"
						 v-bind="$props"
						 :value="text || ''"
						 placeholder='Snabbval'
						 name="snabbval"
						 autocomplete="off">

			</slot>
		</div>
		<div class="suggestions" v-if="!!listShown && !removeList"
			  @mouseenter="hoverList(true)"
			  @mouseleave="hoverList(false)">
			<!-- Tog bort index, för ESLint klagade att den inte används:
				v-for="(suggestion, index) in suggestions" -->
			<div class="suggest-item" v-for="suggestion in suggestions"
				  @mouseenter="hover(suggestion, $event.target)"
				  @mouseleave="hover(null, $event.target)"
				  @click="suggestionClick(suggestion, $event)"
				  :key="suggestion.Id"
				  :class="{
			 selected: selected && (suggestion.Id == selected.Id),
			 hover: hovered && (hovered.Id == suggestion.Id)
		  }">
				<slot name="suggestion-item"
						:autocomplete="() => autocompleteText(suggestion)"
						:suggestion="suggestion"
						:query="text">
					<span>{{ suggestion.Id }} – {{ suggestion.Name }}</span>
				</slot>
			</div>

		</div>
	</div>

</template>

<script>
	// Vi inspireras här av http://fareez.info/blog/vuejs/create-your-own-autocomplete-using-vuejs-2/
	// och av https://alligator.io/vuejs/vue-autocomplete-component/
	// Jag har även knyckt lite (mycket) från https://kazanexpress.github.io/vue-simple-suggest/

	'use strict';

	import { isTouchDevice } from 'isTouchDevice';

	const defaultControls = {
		selectionUp: [38],
		selectionDown: [40],
		select: [13],
		hideList: [27],
		autocomplete: [32, 13]
	}


	//function fromPath(obj, path) {
	//	return path.split('.').reduce((o, i) => (o === Object(o) ? o[i] : o), obj);
	//}

	function hasKeyCode(arr, event) {
		if (arr.length <= 0) return false;

		const has = arr => arr.some(code => code === event.keyCode);
		if (Array.isArray(arr[0])) {
			return arr.some(array => has(array));
		} else {
			return has(arr);
		}
	}

	//let event = 'input';

	export default {
		name: 'autocomplete',

		data() {
			return {
				selected: null,
				hovered: null,
				suggestions: [],
				listShown: false,
				inputElement: null,
				canSend: true,
				timeoutInstance: null,
				text: '', //this.value,
				open: false,
				shadowValue: '',
				isPlainSuggestion: false,
				isClicking: false,
				isOverList: false,
				isInFocus: false,
				isTabbed: false,
				controlScheme: {},
				isTouchDevice: isTouchDevice()
			};
		},

		props: {
			vpAccessKey: {
				type: String,
				default: null
			},
			value: {},
			accounts: {
				type: Array,
				required: true
			},
			minLength: {
				type: Number,
				default: 2
			},
			maxSuggestions: {
				type: Number,
				default: 10
			},
			removeList: {
				type: Boolean,
				default: false
			},
			controls: {
				type: Object,
				default: () => defaultControls
			},
		},

		computed: {
			hoveredIndex() {
				return this.suggestions.findIndex(el => this.hovered && (this.hovered.Id == el.Id))
			},
		},

		created() {
			this.controlScheme = Object.assign({}, defaultControls, this.controls)
			//event = this.mode
		},

		methods: {
			filter(el, value) {
				return (this.filterId(el, value) || this.filterName(el, value));
			},
			filterId(el, value) {
				return (el.Id.toLowerCase().indexOf(value.toLowerCase()) == 0);
			},
			filterName(el, value) {
				return (el.Name.toLowerCase().indexOf(value.toLowerCase()) >= 0);
			},
			moveSelection(e) {
				//console.log('moveSelection(' + e.keyCode + ')');
				if (e.keyCode == 13) {
					//console.log('ENTER');

					if (this.shadowValue != '') {
						this.text = this.shadowValue;
					}
					e.preventDefault();

					if (this.text != '') {
						this.$emit('value-selected', this.text);
					}
				}
				if (hasKeyCode([this.controlScheme.selectionUp, this.controlScheme.selectionDown], e)) {
					e.preventDefault()
					this.showSuggestions();
					const isMovingDown = hasKeyCode(this.controlScheme.selectionDown, e)
					const direction = isMovingDown * 2 - 1
					const listEdge = isMovingDown ? 0 : this.suggestions.length - 1
					const hoversBetweenEdges = isMovingDown ? this.hoveredIndex < this.suggestions.length - 1 : this.hoveredIndex > 0
					let item = null
					if (!this.hovered) {
						item = this.selected || this.suggestions[listEdge]
					} else if (hoversBetweenEdges) {
						item = this.suggestions[this.hoveredIndex + direction]
					} else /* if hovers on edge */ {
						item = this.suggestions[listEdge]
					}
					this.hover(item)
				}
			},
			onListKeyUp(e) {
				//console.log('onListKeyUp');
				const select = this.controlScheme.select,
					hideList = this.controlScheme.hideList
				if (hasKeyCode([select, hideList], e)) {
					e.preventDefault()
					if (this.listShown) {
						if (hasKeyCode(select, e) && this.hovered) {
							this.select(this.hovered)
						}
						this.hideList()
					} else if (hasKeyCode(select, e)) {
						this.research()
					}
				}
			},
			onAutocomplete(e) {
				//console.log('onAutocomplete');
				if (hasKeyCode(this.controlScheme.autocomplete, e)
					&& (e.ctrlKey || e.shiftKey)
					&& (this.suggestions.length > 0 && this.suggestions[0])
					&& (this.listShown)
				) {
					e.preventDefault()
					this.hover(this.suggestions[0])
					this.autocompleteText(this.suggestions[0].Id)
				}
			},
			//hideList() {
			//	if (this.listShown) {
			//		this.listShown = false
			//		this.$emit('hide-list')
			//	}
			//},
			autocompleteText(text) {
				//console.log('autocompleteText');
				this.$emit('input', text);
				this.inputElement.value = text;
				this.text = text;
				this.shadowValue = text;
			},
			select(item) {
				//console.log('select');
				this.hovered = null
				this.selected = item
				this.$emit('select', item)
				this.autocompleteText(item.Id)
				this.$emit('value-selected', this.text);
			},
			hover(item, elem) {
				//console.log('hover');
				this.hovered = item
				if (this.hovered != null) {
					this.$emit('hover', item, elem)
				}
			},
			hoverList(isOverList) {
				//console.log('hoverList');
				this.isOverList = isOverList
			},
			hideList() {
				//console.log('hideList');
				if (this.listShown) {
					this.listShown = false
					this.$emit('hide-list')
				}
			},
			showList() {
				//console.log('showList');
				if (!this.listShown) {
					const textLength = (this.text && this.text.length) || 0;
					if (textLength >= this.minLength && (this.suggestions.length > 0)) {
						this.listShown = true
						this.$emit('show-list')
					}
				}
			},
			async showSuggestions() {
				//console.log('showSuggestions');
				if (this.suggestions.length === 0 && this.minLength === 0 && !this.text) {
					await this.research()
				}
				this.showList()
			},
			suggestionClick(suggestion, e) {
				//console.log('suggestionClick');
				this.$emit('suggestion-click', suggestion, e)
				this.select(suggestion)
				this.hideList()
				/// Ensure, that all needed flags are off before finishing the click.
				this.isClicking = this.isOverList = false
			},


			onFocus(evt) {
				//console.log('onFocus');
				this.open = true;
				this.current = 0;
			},
			onBlur(evt) {
				//console.log('onBlur');
				this.open = false;
				this.current = -1;
			},
			onInput(inputEvent) {
				this.text = inputEvent.target.value
				this.$emit('input', this.text)
				if (this.selected) {
					this.selected = null
					this.$emit('select', null)
				}
				if (this.debounce) {
					clearTimeout(this.timeoutInstance)
					this.timeoutInstance = setTimeout(this.research, this.debounce)
				} else {
					this.research()
				}
			},
			async research() {
				// Leta upp de konton som matchar sökbegreppet
				//console.log('research');

				if (this.canSend) {
					this.canSend = false
					this.$set(this, 'suggestions', await this.getSuggestions(this.text))
					this.canSend = true
				}
				if (this.suggestions.length === 0) {
					this.hideList()
					this.shadowValue = '';
				} else {
					this.showList();

					if (this.filterId(this.suggestions[0], this.text)) {
						this.shadowValue = this.suggestions[0].Id;
					} else {
						this.shadowValue = '';
					}
				}
				return this.suggestions
			},
			async getSuggestions(value = '') {
				// Leta upp de konton som matchar sökbegreppet
				//console.log('getSuggestions(' + value + ')');
				if (this.listShown && !value && this.minLength > 0) {
					this.hideList()
					this.clearSuggestions()
					return this.suggestions
				}
				if (value.length < this.minLength) {
					return this.suggestions
				}
				this.selected = null
				// Start request if can
				let result = []

				result = this.accounts;

				result = result.filter((el) => this.filter(el, value))

				if (this.maxSuggestions) {
					result.splice(this.maxSuggestions)
				}
				return result;

			},
			clearSuggestions() {
				this.suggestions.splice(0)
			},
		},

		mounted() {
			// Note that mounted does not guarantee that all child components have also been mounted.

			this.inputElement = this.$refs['input'];
			this.inputElement.addEventListener('blur', this.onBlur);
			this.inputElement.addEventListener('focus', this.onFocus);

			// AccessKey-hanteringen måste ligga på app-nivån istället, för att kunna hantera att ev dold meny ska öppnas!

		},
		beforeDestroy() {
			this.inputElement.removeEventListener('blur', this.onBlur);
			this.inputElement.removeEventListener('focus', this.onFocus);
		},
	}
</script>
